import { render, staticRenderFns } from "./LegalRoleBusinessRole.vue?vue&type=template&id=21f13b3d&"
import script from "./LegalRoleBusinessRole.vue?vue&type=script&lang=js&"
export * from "./LegalRoleBusinessRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports